/** Извлекает имя файла из пути или URL. */
export const getFileNameFromPath = (path: string): string => {
  try {
    const fileName = path.split('/').pop() || 'file'

    return decodeURIComponent(fileName)
  } catch {
    return path
  }
}

/** Формирует полный URL для скачивания файла (путь или уже полный URL). */
export const getFileUrl = (path: string): string => {
  if (!path || typeof path !== 'string') {
    return ''
  }

  const trimmedPath = path.trim()
  if (!trimmedPath) {
    return ''
  }

  if (
    trimmedPath.startsWith('http://')
    || trimmedPath.startsWith('https://')
    || trimmedPath.startsWith('//')
  ) {
    return trimmedPath
  }

  const baseUrl = import.meta.env.VITE_BASE_URL || ''
  if (baseUrl) {
    const separator = trimmedPath.startsWith('/') ? '' : '/'

    return `${baseUrl}${separator}${trimmedPath}`
  }

  return trimmedPath
}
